import * as React from 'react';
import { Dispatch } from 'redux';
import { compose } from 'util/compose';
import { connect } from 'react-redux';
import { State as AppState } from 'reducers';
import { withTranslation, WithTranslation } from 'react-i18next';
import { getBuildingBroadcastMessage, isSettingBuildingBroadcast, getBuildingBroadcastError } from 'selectors/buildingsSelectors';
import { setBroadcastRequest } from 'actions/buildingActions';
import { urlSlugToBuildingId } from 'ui/shared/urlSlugToBuildingId';
import { ErrorMessage } from 'ui/shared/messages';
import './buildingBroadcastPage.css';

export type OwnProps = {
    buildingId: string;
};
type State = {
    message: string | null;
};

export class BuildingBroadcastPageComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            message: props.liveMessage,
        };
    }

    componentDidMount() {
        if (window) {
            window.onbeforeunload = () => this.promptOnUnsavedChanges();
        }
    }

    componentDidUpdate(oldProps: Props) {
        const { liveMessage } = this.props;
        if (liveMessage !== oldProps.liveMessage) {
            this.setState({
                message: liveMessage,
            });
        }
    }

    componentWillUnmount() {
        if (window) {
            window.onbeforeunload = null;
        }
    }

    promptOnUnsavedChanges() {
        const { liveMessage, t } = this.props;
        const { message } = this.state;
        if (message !== liveMessage) {
            return t("UNSAVED_CHANGES_MESSAGE");
        }
    }
    
    handleChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
        const message = e.currentTarget.value;
        this.setState({
            message,
        });
    };

    handleClickClear = () => {
        this.setState({
            message: '',
        });
        this.props.setBroadcast('');
    };

    handleClickBroadcast = () => {
        this.props.setBroadcast(this.state.message);
    };

    render() {
        const { liveMessage, isSettingBroadcast, error, t } = this.props;
        const { message } = this.state;

        const canBroadcast = message !== liveMessage && !isSettingBroadcast;

        return (
            <div id="building-broadcast-page" className="page">
                <div>
                    { t('BUILDING.BROADCAST.PROMPT') }
                </div>
                <textarea
                    id="broadcast-message"
                    value={ message || '' }
                    onChange={ this.handleChange }
                />
                <div>
                    <button
                        type="button"
                        className="ui primary red button"
                        onClick={ this.handleClickBroadcast }
                        disabled={ !canBroadcast }
                    >
                        { t('COMMAND.BROADCAST') }
                    </button>
                    { message &&
                        <button
                            type="button"
                            className="ui button"
                            onClick={ this.handleClickClear }
                            disabled={ isSettingBroadcast }
                        >
                            { t('COMMAND.CLEAR') }
                        </button>
                    }
                </div>
                <ErrorMessage message={ error }/>
            </div>
        );
    }
}

type StateProps = {
    liveMessage: string | null;
    isSettingBroadcast: boolean;
    error: string | null;
};
type DispProps = {
    setBroadcast(message: string | null): void;
};

const mapStateToProps = (state: AppState, ownProps: OwnProps): StateProps => ({
    liveMessage: getBuildingBroadcastMessage(state, ownProps),
    isSettingBroadcast: isSettingBuildingBroadcast(state, ownProps),
    error: getBuildingBroadcastError(state, ownProps),
});
const mapDispatchToProps = (dispatch: Dispatch, { buildingId }: OwnProps): DispProps => ({
    setBroadcast: message => dispatch(setBroadcastRequest(message, buildingId)),
});

type Props = OwnProps & StateProps & DispProps & WithTranslation;

export const BuildingBroadcastPage = compose(
    withTranslation(),
    urlSlugToBuildingId,
    connect<StateProps, DispProps, OwnProps>(mapStateToProps as any, mapDispatchToProps as any),
)(BuildingBroadcastPageComponent);
